import React, { useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import Footer from '../components/footer';
import { useSanityQuery } from '../../hooks/useSanityQuery';
import { urlFor } from '../../lib/imageUrlFor';

const EVENT_QUERY = `*[_type == "event" && slug.current == $slug][0]{
  title,
  "slug": slug.current,
  heroImage,
  datetime,
  description,
  embedCode
}`;

export default function EventDetail() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { data: event, loading } = useSanityQuery(EVENT_QUERY, { slug });

  // Load any scripts embedded in embedCode (like Ticketbud)
  const embedCode = event?.embedCode;
  useEffect(() => {
    if (!embedCode) return;
    const matches = embedCode.matchAll(/src=['"]([^'"]+)['"]/g);
    const scripts = [];
    for (const match of matches) {
      const script = document.createElement('script');
      script.src = match[1];
      script.async = true;
      document.body.appendChild(script);
      scripts.push(script);
    }
    return () => {
      scripts.forEach((s) => {
        if (document.body.contains(s)) document.body.removeChild(s);
      });
    };
  }, [embedCode]);

  if (loading) {
    return (
      <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <p style={{ color: '#c8b16f' }}>Loading...</p>
      </div>
    );
  }

  if (!event) {
    navigate('/events');
    return null;
  }

  const heroImageUrl = event.heroImage
    ? urlFor(event.heroImage).width(1600).url()
    : './img/event.jpg';

  return (
    <div className='wrapperitem'>
      <section className='jumbotron breadcumb' style={{ position: 'relative', overflow: 'hidden', zIndex: 0 }}>
        <div style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${heroImageUrl})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          filter: 'blur(3px)',
          zIndex: -2,
        }} />
        <div className='mainbreadcumb' style={{ position: 'relative', zIndex: 1 }}>
          <div className='container-fluid'>
            <div className='row m-10-hor'>
              <div className='col-md-6'>
                <h1>{event.title}</h1>
              </div>
              <div className='col-md-6'>
                <div className='list'>
                  <Link className='link' to="/">Home</Link>
                  <span className='dash'>/</span>
                  <Link className='link' to="/events">Events</Link>
                  <span className='dash'>/</span>
                  <span>{event.title}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='container-fluid' id="ticket">
        <div className='row m-10-hor'>
          <div className='col-md-12'>
            {event.datetime && (
              <p style={{ color: '#c8b16f', marginBottom: '20px' }}>{event.datetime}</p>
            )}
            {event.description && (
              <p style={{ marginBottom: '30px' }}>{event.description}</p>
            )}
            {event.embedCode && (
              <div
                className='ticket'
                dangerouslySetInnerHTML={{ __html: event.embedCode }}
              />
            )}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
